import { createFileRoute } from "@tanstack/react-router";
import CarDetail from "@/pages/CarDetailV3";
import { loadListingWithRedirect, listingHead } from "@/lib/seo/listing-seo";

export const Route = createFileRoute("/uk/listing/$slug/")({
  loader: ({ params }) => loadListingWithRedirect(params.slug, "uk"),
  head: ({ loaderData, params }) => listingHead(loaderData ?? null, params.slug, "uk"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <CarDetail />
  );
}
